// Hulhumalé Hospital brand greens (match the mcgh-* Tailwind colours).
// Both pass WCAG AA (≥4.5:1) with white text, unlike Mantine's stock teal/green.
export const BRAND_DARK = "#00493e";
export const BRAND_MEDIUM = "#007e6c";

export const BRAND_GRADIENT = `linear-gradient(135deg, ${BRAND_DARK} 0%, ${BRAND_MEDIUM} 100%)`;
